export default "__VITE_ASSET__DF5W7WCU__"